import React from 'react'
import "../../../assets/vendor_components/bootstrap/dist/css/bootstrap.css"
import "../../../assets/vendor_components/perfect-scrollbar/css/perfect-scrollbar.css"
import "../../../assets/vendor_components/morris.js/morris.css"
import "../../../assets/vendor_components/OwlCarousel2/dist/assets/owl.carousel.css"
import "../../../assets/vendor_components/OwlCarousel2/dist/assets/owl.theme.default.min.css"
import "../../../assets/vendor_components/horizontal-timeline/css/horizontal-timeline.css"
import "../../../assets/vendor_components/flexslider/flexslider.css"
import "../../../assets/vendor_components/prism/prism.css"
import "../../../assets/vendor_components/datatable/datatables.min.css"
import "../../../assets/vendor_components/Magnific-Popup-master/dist/magnific-popup.css"
import "../../../assets/vendor_components/gallery/css/animated-masonry-gallery.css"
import "../../../assets/vendor_components/lightbox-master/dist/ekko-lightbox.css"
import "../../../assets/vendor_components/jvectormap/lib2/jquery-jvectormap-2.0.2.css"
import "../../../assets/vendor_components/x-editable/dist/bootstrap3-editable/css/bootstrap-editable.css"
import "../../../assets/vendor_components/sweetalert/sweetalert.css"
import "../../../assets/vendor_components/bootstrap-markdown-master/css/bootstrap-markdown.css"
import "../../../assets/vendor_components/dropzone/dropzone.css"
import "../../../assets/vendor_components/select2/dist/css/select2.min.css"
import "../../../assets/vendor_components/date-paginator/bootstrap-datepaginator.min.css"
import "../../../assets/vendor_components/bootstrap-daterangepicker/daterangepicker.css"
import "../../../assets/vendor_components/bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css"
import "../../../assets/vendor_components/bootstrap-colorpicker/dist/css/bootstrap-colorpicker.min.css"
import "../../../assets/vendor_components/bootstrap-select/dist/css/bootstrap-select.css"
import "../../../assets/vendor_components/bootstrap-tagsinput/dist/bootstrap-tagsinput.css"
import "../../../assets/vendor_components/bootstrap-touchspin/dist/jquery.bootstrap-touchspin.css"
import "../../../assets/vendor_components/raty-master/lib/jquery.raty.css"
import "../../../assets/vendor_components/ion-rangeSlider/css/ion.rangeSlider.css"
import "../../../assets/vendor_components/ion-rangeSlider/css/ion.rangeSlider.skinModern.css"
import "../../../assets/vendor_components/gridstack/gridstack.css"
import "../../../assets/vendor_components/jquery-toast-plugin-master/src/jquery.toast.css"
import "../../../assets/vendor_components/nestable/nestable.css"
import "../../../assets/vendor_components/bootstrap-switch/switch.css"
import "../../../assets/vendor_components/c3/c3.min.css"
import "../../../assets/vendor_components/chartist-js-develop/chartist.css"
import "../../../assets/vendor_plugins/bootstrap-slider/slider.css"
import "../../../assets/vendor_plugins/iCheck/flat/blue.css"
import "../../../assets/vendor_plugins/bootstrap-wysihtml5/bootstrap3-wysihtml5.min.css"
import "../../../assets/vendor_plugins/bootstrap-wysihtml5/bootstrap3-wysihtml5.css"
import "../../../assets/vendor_plugins/iCheck/all.css"
import "../../../assets/vendor_plugins/timepicker/bootstrap-timepicker.min.css"
import "../../../assets/vendor_plugins/pace/pace.min.css"
import "../../../assets/vendor_components/fullcalendar/fullcalendar.min.css"
import "../../../assets/vendor_components/fullcalendar/fullcalendar.print.min.css"
import "../../../assets/vendor_components/weather-icons/weather-icons.css"
import "../../../assets/vendor_components/animate/animate.css"
import "../../../assets/css/style_rtl.css"
import "../../../assets/icons/font-awesome/css/font-awesome.css"
import "../../../assets/icons/Ionicons/css/ionicons.css"
import "../../../assets/icons/themify-icons/themify-icons.css"
import "../../../assets/icons/linea-icons/linea.css"
import "../../../assets/icons/glyphicons/glyphicon.css"
import "../../../assets/icons/flag-icon-css/css/flag-icon.css"
import "../../../assets/icons/material-design-iconic-font/css/materialdesignicons.css"
import "../../../assets/icons/simple-line-icons/css/simple-line-icons.css"
import "../../../assets/icons/cryptocoins-master/cryptocoins.css"
import "../../../assets/icons/weather-icons/css/weather-icons.min.css"
import "../../../assets/icons/iconsmind/style.css"
import "../../../assets/icons/icomoon/style.css"
import "../../../assets/css/vendors_css.css"
import "../../../assets/css/skin_color.css"
import "../../../assets/css/style.css"
import "../../../assets/css/color_theme.css"
import "../../../App.css"

const ThemeWrapper = ({children}) => {
  return (
    <>
      {children}
    </>
  )
}

export default ThemeWrapper;